"use strict";
/* eslint-disable prefer-object-spread */
const en = require('./en');
module.exports = Object.assign({}, en, {
    '@lemonone/intl/deliverable:photos': 'Min {photos} Fotos',
    '@lemonone/intl/deliverable:internalWalkVideo': 'Walk-Through-Video',
    '@lemonone/intl/deliverable:proWalkVideo': 'Professionelles Walk-Through-Video',
    '@lemonone/intl/deliverable:floorplan': 'Grundriss',
    '@lemonone/intl/deliverable:tour360': '360-Tour',
    '@lemonone/intl/equipment:lightsExternalStudioLight': 'Studiobeleuchtung',
    '@lemonone/intl/equipment:lightsReflector': 'Reflektor',
    '@lemonone/intl/equipment:lightsLightbox': 'Leuchtkasten',
    '@lemonone/intl/equipment:lightsSoftbox': 'Softbox',
    '@lemonone/intl/equipment:backgroundsBackdropsColors': 'Hintergründe',
    '@lemonone/intl/equipment:backgroundsPaperBackgrounds': 'Papierhintergründe',
    '@lemonone/intl/equipment:wideAngleLens': 'Weitwinkelobjektiv (16 - 20mm Vollbild oder gleichwertig)',
    '@lemonone/intl/equipment:threesixty': '360-Kit',
    '@lemonone/intl/equipment:teleLens': 'Teleobjektiv',
    '@lemonone/intl/equipment:videoGimbal': 'Gimbal',
    '@lemonone/intl/equipment:videoExternalMicrophone': 'Mikrofon',
    '@lemonone/intl/equipment:floorplan': 'Floor plan',
    '@lemonone/intl/equipment:detailLens': 'Detail / Portrait Objektiv',
    '@lemonone/intl/equipment:extensionArmTripod': 'Stativ mit einem Verlängerungsarm',
    '@lemonone/intl/equipment:tiltShiftLense': 'Tilt-shift Objektiv',
    '@lemonone/intl/equipment:camera360': '360 Kamera',
    '@lemonone/intl/equipment:14-24mmFullFrameOr10-16CropSensor': '14-24mm (10-16mm crop), APS-C Sensor oder Vollformatkamera',
    '@lemonone/intl/equipment:14-20mmFullFrame': '14-20mm Linse, Vollformatkamera',
    '@lemonone/intl/equipment:20mmFullFrame': '20mm Linse, Vollformatkamera',
    '@lemonone/intl/equipment:12MP+Drone': '12MP+ Drone',
    '@lemonone/intl/equipment:20MP+Drone': '20MP+ Drone',
    '@lemonone/intl/equipment:32MP+Drone': '32MP+ Drone',
    '@lemonone/intl/equipment:UAVLicense': 'Drohnenlizenz (notwendig)',
    '@lemonone/intl/equipment:droneWorkAccidentLiabilityInsurance': 'Berufshaftpflichtversicherung inkl. Drohne',
    '@lemonone/intl/equipment:matterportCompatibleCamera': 'Matteport kompatible Kamera https://matterport.com',
    '@lemonone/intl/equipment:ricoThetaZ1': 'RicoThetaZ1, https://matterport.com',
    '@lemonone/intl/equipment:matterportPro2OrLeicaBLK360': 'Matterport Pro2 oder Leica BLK360, https://matterport.com',
    '@lemonone/intl/equipment:35mm+CropOrFullFrame': 'min. 35mm Linse, APS-C Sensor oder Vollformatkamera',
    '@lemonone/intl/equipment:F2.8+Lens90Tripod15-30mmFullFrame': 'min. F 2.8 Linse, Stativ mit 90° Zusatzneiger, 15-30mm Linse, Vollformatkamera',
    '@lemonone/intl/equipment:magicPlan': '<a href="https://www.magicplan.app" target="_blank">MagicPlan App installiert</a>',
    '@lemonone/intl/text:date': 'Datum',
    '@lemonone/intl/text:address': 'Adresse',
    '@lemonone/intl/text:location': 'Standort',
    '@lemonone/intl/text:duration': 'Dauer',
    '@lemonone/intl/text:product': 'Produkt',
    '@lemonone/intl/text:id': 'ID',
    '@lemonone/intl/text:orderId': 'Auftragsnummer',
    '@lemonone/intl/text:externalReference': 'Ihre interne ID',
    '@lemonone/intl/text:estimation': 'geschätzte Dauer',
    '@lemonone/intl/text:duration_hours': '{hours, plural, =0 {} one {{hours} Stunde} other {{hours} Stunden}} {minutes, plural, =0 {} one {{minutes} Minute} other {{minutes} Minuten}}',
    '@lemonone/intl/text:estimatedDuration': 'ca. {hours, plural, =0 {} one {{hours} Stunde} other {{hours} Stunden}} {minutes, plural, =0 {} one {{minutes} Minute} other {{minutes} Minuten}}',
    '@lemonone/intl/text:required': 'erforderlich',
    '@lemonone/intl/text:required_datetime': 'Bitte wählen Sie ein Datum und eine Uhrzeit',
    '@lemonone/intl/text:addressSyntax': 'Adresssyntax',
    '@lemonone/intl/text:streetName': 'Straßenname',
    '@lemonone/intl/text:houseNumber': 'Hausnummer',
    '@lemonone/intl/text:zipCode': 'Postleitzahl',
    '@lemonone/intl/text:city': 'Stadt',
    '@lemonone/intl/text:country': 'Land',
    '@lemonone/intl/text:termsAndConditions': 'Allgemeine Geschäftsbedingungen',
    '@lemonone/intl/text:termsAndConditionsUrl': 'https://www.lemonone.com/de/allgemeine-geschaeftsbedingungen',
    '@lemonone/intl/text:privacyPolicy': 'Datenschutz',
    '@lemonone/intl/text:privacyPolicyUrl': 'https://www.lemonone.com/de/vatenschutzerklarung',
    '@lemonone/intl/text:externalId': 'Referenz ID',
    '@lemonone/intl/text:photoshootId': 'Fotoshooting-ID',
    '@lemonone/intl/text:feedback': 'Rückmeldung',
    '@lemonone/intl/text:notes': 'Anmerkungen',
    '@lemonone/intl/text:price': 'Preis',
    '@lemonone/intl/text:email': 'Email'
});
//# sourceMappingURL=de.js.map